import { useLoadingMessages } from '../hooks/useLoadingMessages';

export const LoadingFallback = () => {
  const msg = useLoadingMessages();
  return <div>{msg.loading}</div>;
};
